import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { compose } from 'redux';

// GLOBAL VARIABLES
import { DATE } from 'defaults.js';

// HELPERS
import { applyRange } from '../helpers/applyRange';

// CORE COMPONENTS
import Sprite from 'core/tools/Sprite';

// LOCAL COMPONENTS
import DatePicker from '../parts/DatePicker';

// STYLES
import styles from './rangePicker.module.scss';

// LOCAL VARIABES
const COLS = {
  inline: {
    xs: 'auto'
  },
  default: {
    xs: 12
  }
};

// MAIN COMPONENT
const RangePicker = compose(
  applyRange //
)(
  ({
    endDate, //
    endDateError,
    endName,
    maxDate,
    minDate,
    onStartDateSelect,
    onEndDateSelect,
    required,
    startDate,
    startDateError,
    startName,
    showArrow,
    ...props
  }) => {
    // PROPS
    const { inline, vertical, columns, fullWidth } = props;

    return (
      <>
        <DatePicker
          name={startName}
          formGroup={{
            className: clsx(
              styles.apply,
              styles.picker,
              styles.rangePicker,
              styles.fromPicker,
              inline && styles.inline,
              vertical && styles.vertical,
              columns && styles.columns,
              fullWidth && styles.fullWidth
            ),
            cols: {
              xs: 12
            }
          }}
          cols={inline ? COLS.inline : COLS.default}
          prepend={{
            label: DATE.fromPrepend
          }}
          currentDate={startDate}
          startDate={startDate}
          endDate={endDate}
          minDate={minDate}
          maxDate={endDate || maxDate}
          required={!!endDate || !!required}
          onSelect={onStartDateSelect}
          error={startDateError}
          {...props}
          size="sm"
        />
        {showArrow && (
          <Sprite
            use="arrow-right"
            fill="gray-600"
            size="sm"
            className={clsx(styles.arrow, 'd-none d-lg-block text-gray-600')}
          />
        )}
        <DatePicker
          name={endName}
          formGroup={{
            className: clsx(
              styles.apply,
              styles.picker,
              styles.rangePicker,
              inline && styles.inline,
              vertical && styles.vertical,
              columns && styles.columns,
              fullWidth && styles.fullWidth
            ),
            cols: {
              xs: 12
            }
          }}
          cols={inline ? COLS.inline : COLS.default}
          prepend={{
            label: DATE.toPrepend
          }}
          currentDate={endDate}
          startDate={startDate}
          endDate={endDate}
          minDate={startDate || minDate}
          maxDate={maxDate}
          required={!!startDate || !!required}
          onSelect={onEndDateSelect}
          error={endDateError}
          {...props}
          size="sm"
        />
      </>
    );
  }
);

// EXPORT
export default RangePicker;
